"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PartialSubMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formatID = _interopRequireDefault(require("../../../utils/formatID"));
var _lodash = require("lodash");
var _NavBar = require("../../NavBar/NavBar");
var _LunaLink = _interopRequireDefault(require("../../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const PartialSubMenu = props => {
  const {
    menuProps
  } = props;
  const {
    category,
    deployedSubsection,
    Link,
    mouseLeave
  } = menuProps;
  const {
    mouse
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: category?.contentfulId
  }, (category?.url || category?.link?.url) && /*#__PURE__*/_react.default.createElement("div", {
    // id={uniqueId("id-")}
    className: "ter-mega-menu__left-title",
    "aria-controls": `${category?.text}-mega-menu-title-link`
  }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    to: category?.url || category?.link?.url
    // id={`${category?.text}-mega-menu-title-link${uniqueId("-")}`}
    ,
    Link: Link,
    depth: 2,
    tabIndex: mouse ? "" : "0",
    className: `ter-mega-menu__left-title ter-mega-menu__left-title--link ${deployedSubsection === category?.contentfulId ? "ter-mega-menu__left-title--is-open" : ""} ${mouse ? "" : "tabFocus"}`,
    onClick: () => {
      mouseLeave();
    },
    target: typeof category?.external === 'boolean' ? category?.external ? "_blank" : "_self" : null
  }, /*#__PURE__*/_react.default.createElement("p", {
    // id={formatID(`${category?.text}-mega-menu-title-link-text`)}
    className: ` ter-mega-menu__left-title--text ${deployedSubsection === category?.contentfulId ? "ter-mega-menu__left-title--text--is-open" : ""} `
  }, category?.text))), deployedSubsection === category?.contentfulId && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-right-section ter-right-section__fill-placeholder"
  }));
};
exports.PartialSubMenu = PartialSubMenu;